import React from 'react'
import {
  Table,
  Icon,
  Modal
} from 'antd'
import moment from 'moment'

import './styles.scss'

class HybrikJobs extends React.Component {

  state = {}
  dateFormat = 'MM/DD/YYYY hh:mm:ss'
  columns = [{
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
    render: (value) => <p className='job-name'>{value}</p>
  }, {
    title: 'Creation Time',
    dataIndex: 'creation_time',
    key: 'creation_time',
    render: (value) => <p>{moment(value).format(this.dateFormat)}</p>
  }, {
    title: 'Progress',
    dataIndex: 'progress',
    key: 'progress',
    render: (value) => <p>{value}%</p>
  }]

  componentDidMount() {
    const { filter } = this.props
    const errorCol = {
      title: 'Error',
      key: 'error',
      render: (text, record) =>
        <Icon
          className='exclamation-circle'
          type='exclamation-circle'
          onClick={() => Modal.error({ content: record.error })}
        />
    }
    const endTimeCol = {
      title: 'End Time',
      dataIndex: 'end_time',
      key: 'end_time',
      render: (value) => <p>{moment(value).format(this.dateFormat)}</p>
    }
    if (filter === 'completed' || filter === 'failed') {
      // show end_time on completed/failed jobs
      this.columns.push(endTimeCol)
    }
    if (filter === 'failed') {
      // show error on failed jobs
      this.columns.push(errorCol)
    }
  }

  render() {
    return (
      <Table
        loading={!this.props.data}
        columns={this.columns}
        dataSource={this.props.data}
        rowKey='id'
        className='hybrik-jobs'
        size='small'
      />
    )
  }
}

export default HybrikJobs
